import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../_base/crud';
import { ImmunizationsState } from '../_reducers/immunization.reducers';
import { Immunization } from '../_models/immunization.model';

export const selectImmunizationsState = createFeatureSelector<ImmunizationsState>('immunizations');

export const selectImmunizationById = (immunizationId: number) =>
  createSelector(selectImmunizationsState, (immunizationsState) => {
    return immunizationsState.entities[immunizationId];
  });

export const selectImmunizationsPageLoading = createSelector(
  selectImmunizationsState,
  (immunizationsState) => immunizationsState.loading,
);

export const selectCurrentEntityIdInStoreForImmunization = createSelector(
  selectImmunizationsState,
  (immunizationsState) => immunizationsState.entityId,
);

export const selectImmunizationsWaitingMessage = createSelector(
  selectImmunizationsState,
  (immunizationsState) => immunizationsState.showInitWaitingMessage,
);

export const selectImmunizationsActionLoading = createSelector(
  selectImmunizationsState,
  (immunizationsState) => immunizationsState.actionsloading,
);

export const selectImmunizationErrorState = createSelector(
  selectImmunizationsState,
  (immunizationState) => immunizationState.error,
);

export const selectImmunizationsInStore = createSelector(
  selectImmunizationsState,
  (immunizationsState) => {
    const items: Immunization[] = [];
    each(immunizationsState.entities, (element) => {
      items.push(element);
    });

    return new QueryResultsModel(items, immunizationsState.totalCount);
  },
);
